import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { NAVBAR_TAB_NAMES } from "../const/navbarTabNames";

export const useGetOnlinesDesignTabs = () => {

    const location = useLocation()
    const { t } = useTranslation()
    const userParam = sessionStorage.getItem("userParam");

    return {
        [NAVBAR_TAB_NAMES.onlines_portfolio]: {
            active: location.pathname === "/portfolio",
            content: t("onlinesNav.portfolio"),
            linkTo: `/portfolio${userParam}`,
        },
        [NAVBAR_TAB_NAMES.onlines_communication]: {
            active: location.pathname === "/graphic-design-basic-level",
            content: t("onlinesNav.communication"),
            linkTo: `/graphic-design-basic-level${userParam}`,
        },
        [NAVBAR_TAB_NAMES.onlines_school]: {
            active: location.pathname === "/school",
            content: t("onlinesNav.school"),
            linkTo: `/school${userParam}`,
        },
        [NAVBAR_TAB_NAMES.onlines_library]: {
            active: location.pathname.includes("/library"),
            content: 'Library',
            linkTo: `/library${userParam}`,
        },
    }
}import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { NAVBAR_TAB_NAMES } from "../const/navbarTabNames";

export const useGetOnlinesDesignTabs = () => {

    const location = useLocation()
    const { t } = useTranslation()
    const userParam = sessionStorage.getItem("userParam");

    return {
        [NAVBAR_TAB_NAMES.onlines_portfolio]: {
            active: location.pathname === "/portfolio",
            content: t("onlinesNav.portfolio"),
            linkTo: `/portfolio${userParam}`,
        },
        [NAVBAR_TAB_NAMES.onlines_communication]: {
            active: location.pathname === "/graphic-design-basic-level",
            content: t("onlinesNav.communication"),
            linkTo: `/graphic-design-basic-level${userParam}`,
        },
        [NAVBAR_TAB_NAMES.onlines_school]: {
            active: location.pathname === "/school",
            content: t("onlinesNav.school"),
            linkTo: `/school${userParam}`,
        },
        [NAVBAR_TAB_NAMES.onlines_library]: {
            active: location.pathname.includes("/library"),
            content: 'Library',
            linkTo: `/library${userParam}`,
        },
    }
}